// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function FeedbackSheet({
  open,
  isFeedbackEnabled,
  isRateAppEnabled,
  onFeedbackClick,
  onRateAppClick,
}) {
  const items = [
    {
      key: "feedback",
      label: "Share Feedback",
      title: "Tell us what is working and what is not",
      onClick: onFeedbackClick,
      enabled: isFeedbackEnabled !== false,
    },
    {
      key: "rate",
      label: "Rate App",
      title: "Leave a review on the Chrome Web Store",
      onClick: onRateAppClick,
      enabled: isRateAppEnabled !== false,
    },
  ].filter((item) => item.enabled);

  return (
    <div
      id="mood-sheet"
      className={`mood mood--feedback${open ? " mood--open" : ""}`}
      aria-label="Feedback"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Feedback</div>
        <p className="mood__subtitle">Tell us how Slowed is going.</p>
      </div>

      <div className="mood__chips-wrap">
        <div className="mood__chips">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              className="mood__chip"
              onClick={() => item.onClick?.()}
              title={item.title}
              tabIndex={open ? 0 : -1}
            >
              <span className="mood__chip-name">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
